import { render, staticRenderFns } from "./business-admin-list.vue?vue&type=template&id=fb8b94d0&scoped=true&"
import script from "./business-admin-list.vue?vue&type=script&lang=js&"
export * from "./business-admin-list.vue?vue&type=script&lang=js&"
import style0 from "./business-admin-list.vue?vue&type=style&index=0&id=fb8b94d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8b94d0",
  null
  
)

export default component.exports